'use client';

export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Slide/index.js
// module id = 519
// module chunks = 25